import type React from 'react';

export type CheckboxInputProps = React.InputHTMLAttributes<HTMLInputElement>;

export function CheckboxInput({ className, ...props }: CheckboxInputProps): JSX.Element {
  return (
    <input
      type="checkbox"
      className={[
        'h-4 w-4 rounded border-slate-300 text-slate-600',
        'focus:ring-slate-500',
        'disabled:cursor-not-allowed disabled:text-slate-400',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  );
}
